import { cn } from '@exam-room/utils';

type SkeletonProps = React.ComponentProps<'div'>;

export default function TimerSkeleton({ className, ...props }: SkeletonProps) {
  return <div className={cn('animate-pulse rounded-md bg-slate-200 p-2', className)} {...props} />;
}
